// extracted by mini-css-extract-plugin
module.exports = {"underline":"sectionTitleComponent_underline__2Wqgz","centered":"sectionTitleComponent_centered__30lCi","primary":"sectionTitleComponent_primary__3PsN7","secondary":"sectionTitleComponent_secondary__2iD9Z","white":"sectionTitleComponent_white__1vQEk"};
    if(module.hot) {
      // 1745223369026
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  